import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchAllRoles } from 'src/api/roles';
import { FETCH_ALL_ROLES, requestAllRoles, requestAllRolesFailure, requestAllRolesSuccess } from './actions';

function* fetchAllRolesSaga(action: AnyAction): SagaIterator {
    yield put(requestAllRoles());

    const { error, response } = yield call(fetchAllRoles);

    if (error) {
        yield put(requestAllRolesFailure(error));
    } else {
        yield put(requestAllRolesSuccess(response));
    }
}

export function* generateFetchAllRoles() {
    yield takeLatest(FETCH_ALL_ROLES, fetchAllRolesSaga);
}
